import { render, staticRenderFns } from "./DisputeView.vue?vue&type=template&id=ee610150&"
import script from "./DisputeView.vue?vue&type=script&lang=js&"
export * from "./DisputeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports